import React,{useState,useEffect} from 'react'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import { flexValueTable } from '../../../utils/AdminDashApi/FlexValue'
import ReactPaginate from 'react-paginate';
import StuDashNavbarSidebarmb from '../../mobile/StuDashNavbarSidebarmb'
import AdminDashSidebarSidebarComp from '../../mobile/AdminDashSidebarSidebarComp'
import {AiOutlinePlus} from 'react-icons/ai'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp';
import Purplebutton from '../desktop/subComponent/Purplebutton';

const FlexvalueCompmb = () => {

  const [flexvaluesetdrp,setflexvaluesetdrp] = useState("")
  const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
 
  
  const [activetonewFlexValue,setactiveTonewFlexValue] = useState("")

  const [flexnameMod1,setflexnameMod1] = useState("")
  const [labelflexnameMod1,setlabelflexnameMod1] = useState("")
  const [borderflexnameMod1,setborderflexnameMod1] = useState("")

  const [flexnameMod2,setflexnameMod2] = useState("")
  const [labelflexnameMod2,setlabelflexnameMod2] = useState("")
  const [borderflexnameMod2,setborderflexnameMod2] = useState("")

  const [shortnameMain,setshortnameMain] = useState("")
  const [labelshortnameMain,setlabelshortnameMain] = useState("")
  const [bordershortnameMain,setbordershortnameMain] = useState("")

  const [flexvaluesetidMod1,setflexvaluesetidMod1] = useState("")
  const [labelflexvaluesetidMod1,setlabelflexvaluesetidMod1] = useState("")
  const [borderflexvaluesetidMod1,setborderflexvaluesetidMod1] = useState("")

  const [flexshortnameMod1,setflexshortnameMod1] = useState("")
  const [labelflexshortnameMod1,setlabelflexshortnameMod1] = useState("")
  const [borderflexshortnameMod1,setborderflexshortnameMod1] = useState("")

  const [flexshortnameMod2,setflexshortnameMod2] = useState("")
  const [labelflexshortnameMod2,setlabelflexshortnameMod2] = useState("")
  const [borderflexshortnameMod2,setborderflexshortnameMod2] = useState("")

  const [flexvalueMod1,setflexvalueMod1] = useState("")
  const [borderflexvalueMod1,setborderflexvalueMod1] = useState("")
  const [labelflexvalueMod1,setlabelflexvalueMod1] = useState("")


  const [activefromMod1,setactivefromMod1] = useState("")
  const [borderactivefromMod1,setborderactivefromMod1] = useState("")
  const [labelactivefromMod1,setlabelactivefromMod1] = useState("")

  const [activetoMod1,setactivetoMod1] = useState("")
  const [borderactivetoMod1,setborderactivetoMod1] = useState("")
  const [labelactivetoMod1,setlabelactivetoMod1] = useState("")

  const [flexvaluesetidMod2,setflexvaluesetidMod2] = useState("")
  const [labelflexvaluesetidMod2,setlabelflexvaluesetidMod2] = useState("")
  const [borderflexvaluesetidMod2,setborderflexvaluesetidMod2] = useState("")

  const [flexvalueMod2,setflexvalueMod2] = useState("")
  const [borderflexvalueMod2,setborderflexvalueMod2] = useState("")
  const [labelflexvalueMod2,setlabelflexvalueMod2] = useState("")

  const [flexshortvalueMod2,setflexshortvalueMod2] = useState("")
  const [borderflexshortvalueMod2,setborderflexshortvalueMod2] = useState("")
  const [labelflexshortvalueMod2,setlabelflexshortvalueMod2] = useState("")

  const [activefromMod2,setactivefromMod2] = useState("")
  const [borderactivefromMod2,setborderactivefromMod2] = useState("")
  const [labelactivefromMod2,setlabelactivefromMod2] = useState("")

  const [activetoMod2,setactivetoMod2] = useState("")
  const [borderactivetoMod2,setborderactivetoMod2] = useState("")
  const [labelactivetoMod2,setlabelactivetoMod2] = useState("")

  const [flexsetnamemod3,setflexsetnamemod3] = useState("")
  const [borderflexsetnamemod3,setborderflexsetnamemod3] = useState("")
  const [labelflexsetnamemod3,setlabelflexsetnamemod3] = useState("")
  
  const [flexshortnamemod3,setflexshortnamemod3] = useState("")
  const [borderflexshortnamemod3,setborderflexshortnamemod3] = useState("")
  const [labelflexshortnamemod3,setlabelflexshortnamemod3] = useState("")

  const [attribute1Mod1,setattribute1Mod1] = useState("")
  const [labelattribute1Mod1,setlabelattribute1Mod1] = useState("")
  const [borderattribute1Mod1,setborderattribute1Mod1] = useState("")

  const [attribute2Mod1, setattribute2Mod1] = useState("");
  const [labelattribute2Mod1, setlabelattribute2Mod1] = useState("");
  const [borderattribute2Mod1, setborderattribute2Mod1] = useState("");
  
  const [attribute3Mod1, setattribute3Mod1] = useState("");
  const [labelattribute3Mod1, setlabelattribute3Mod1] = useState("");
  const [borderattribute3Mod1, setborderattribute3Mod1] = useState("");
  
  const [attribute4Mod1, setattribute4Mod1] = useState("");
  const [labelattribute4Mod1, setlabelattribute4Mod1] = useState("");
  const [borderattribute4Mod1, setborderattribute4Mod1] = useState("");
  
  const [attribute5Mod1, setattribute5Mod1] = useState("");
  const [labelattribute5Mod1, setlabelattribute5Mod1] = useState("");
  const [borderattribute5Mod1, setborderattribute5Mod1] = useState("");

  const [attribute1Mod2,setattribute1Mod2] = useState("")
  const [labelattribute1Mod2,setlabelattribute1Mod2] = useState("")
  const [borderattribute1Mod2,setborderattribute1Mod2] = useState("")

  const [attribute2Mod2, setattribute2Mod2] = useState("");
  const [labelattribute2Mod2, setlabelattribute2Mod2] = useState("");
  const [borderattribute2Mod2, setborderattribute2Mod2] = useState("");
  
  const [attribute3Mod2, setattribute3Mod2] = useState("");
  const [labelattribute3Mod2, setlabelattribute3Mod2] = useState("");
  const [borderattribute3Mod2, setborderattribute3Mod2] = useState("");
  
  const [attribute4Mod2, setattribute4Mod2] = useState("");
  const [labelattribute4Mod2, setlabelattribute4Mod2] = useState("");
  const [borderattribute4Mod2, setborderattribute4Mod2] = useState("");
  
  const [attribute5Mod2, setattribute5Mod2] = useState("");
  const [labelattribute5Mod2, setlabelattribute5Mod2] = useState("");
  const [borderattribute5Mod2, setborderattribute5Mod2] = useState("");
  



  const handlesaveMod1=()=>{

    let isFormvalid = false 
    const validationResults = [];

    validationResults.push(validationDrp(flexnameMod1,setlabelflexnameMod1,setborderflexnameMod1,"Flex Value required"))
    validationResults.push(validationDrp(flexshortnameMod1,setlabelflexshortnameMod1,setborderflexshortnameMod1,"Flex Short Name required"))
    validationResults.push(validationDrp(attribute1Mod1,setlabelattribute1Mod1,setborderattribute1Mod1,"Attribute 1 required"))
    validationResults.push(validationDrp(attribute2Mod1,setlabelattribute2Mod1,setborderattribute2Mod1,"Attribute 2 required"))
    validationResults.push(validationDrp(attribute3Mod1,setlabelattribute3Mod1,setborderattribute3Mod1,"Attribute 3 required"))
    validationResults.push(validationDrp(attribute4Mod1,setlabelattribute4Mod1,setborderattribute4Mod1,"Attribute 4 required"))
    validationResults.push(validationDrp(attribute5Mod1,setlabelattribute5Mod1,setborderattribute5Mod1,"Attribute 5 required"))
    validationResults.push(validationDrp(activefromMod1,setlabelactivefromMod1,setborderactivefromMod1,"Active From Required"))
    validationResults.push(validationDrp(activetoMod1,setlabelactivetoMod1,setborderactivetoMod1,"Active To Required"))


    if(isFormvalid){
      const Mod1FinalArray = {
        "flexnameMod1":flexnameMod1,
        "flexshortnameMod1":flexshortnameMod1,
        "attribute1Mod1":attribute1Mod1,
        "attribute2Mod1":attribute2Mod1,
        "attribute3Mod1":attribute3Mod1,
        "attribute4Mod1":attribute4Mod1,
        "attribute5Mod1":attribute5Mod1,
        "activefromMod1":activefromMod1,
        "activetoMod1":activetoMod1,
      }
      setShow2(false)
    }

  }

  const handlesaveMod2=()=>{
    let isFormvalid = false 
    const validationResults = [];
    validationResults.push(validationDrp(flexnameMod2,setlabelflexnameMod2,setborderflexnameMod2,"Flex Value required"))
    validationResults.push(validationDrp(flexshortnameMod2,setlabelflexshortnameMod2,setborderflexshortnameMod2,"Flex Short Name required"))
    validationResults.push(validationDrp(attribute1Mod2,setlabelattribute1Mod2,setborderattribute1Mod2,"Attribute 1 required"))
    validationResults.push(validationDrp(attribute2Mod2,setlabelattribute2Mod2,setborderattribute2Mod2,"Attribute 2 required"))
    validationResults.push(validationDrp(attribute3Mod2,setlabelattribute3Mod2,setborderattribute3Mod2,"Attribute 3 required"))
    validationResults.push(validationDrp(attribute4Mod2,setlabelattribute4Mod2,setborderattribute4Mod2,"Attribute 4 required"))
    validationResults.push(validationDrp(attribute5Mod2,setlabelattribute5Mod2,setborderattribute5Mod2,"Attribute 5 required")  )
    validationResults.push(validationDrp(activefromMod2,setlabelactivefromMod2,setborderactivefromMod2,"Active From Required")  )
    validationResults.push(validationDrp(activetoMod2,setlabelactivetoMod2,setborderactivetoMod2,"Active To Required"))

    
    if(isFormvalid){

      const Mod2FinalArray = {
        "flexnameMod2":flexnameMod2,
        "flexshortnameMod2":flexshortnameMod2,
        "attribute1Mod2":attribute1Mod2,
        "attribute2Mod2":attribute2Mod2,
        "attribute3Mod2":attribute3Mod2,
        "attribute4Mod2":attribute4Mod2,
        "attribute5Mod2":attribute5Mod2,
        "activefromMod2":activefromMod2,
        "activetoMod2":activetoMod2,
      }
      setShow3(false)
    }
    
  }
  const handlesavemod3=()=>{
    let isFormvalid = false 
    const validationResults = [];
    validationResults.push(validationComp(flexshortnamemod3,setlabelflexshortnamemod3,setborderflexshortnamemod3,"Flex Short Name Required"))    
    validationResults.push(validationComp(flexsetnamemod3,setlabelflexsetnamemod3,setborderflexsetnamemod3,"Flex Set Name Required"))

    if(isFormvalid){
      const mod3FinalArr = 
        {
          "shortName":flexshortnamemod3,
          "setName":flexsetnamemod3
        }

        setShow4(false)
    }
    
  }


  const [show,setShow] = useState("")

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)

  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4,setShow4] = useState(false);

  const handleClose = () => setShow2(false);
  const handleShow = () => setShow2(true);

  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);
  
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const handleactivetoMod1 = (activetoval)=>{

    if(activetoval != null){

        var dtmnt = activetoval.$M + 1;
        var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
        setactivetoMod1(dtfinalc)
    }
    
    
}
const handleactivefromMod1 = (activefromval)=>{

  if(activefromval != null){

      var dtmnt = activefromval.$M + 1;
      var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
      setactivefromMod1(dtfinalc)
  }
  
  
}
  const handleactivetoMod2 = (activetoval)=>{

    if(activetoval != null){

        var dtmnt = activetoval.$M + 1;
        var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
        setactivetoMod2(dtfinalc)
    }
    
    
}
const handleactivefromMod2 = (activefromval)=>{

  if(activefromval != null){

      var dtmnt = activefromval.$M + 1;
      var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
      setactivefromMod2(dtfinalc)
  }
  
  
}

  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    setCurrentItems(flexValueTable.data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(flexValueTable.data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = event.selected * itemsPerPage % flexValueTable.data.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setpaginatenumselected(event.selected);
    setItemOffset(newOffset);
  };
  const optionsFlexValueSet = [
    {
      id:1,
      opt:"Religion"
    },
    {
      id:2,
      opt:"Gender"
    },
    {
      id:3,
      opt:"Leave Type"
    },
  ]
  const optionsShowt = [
    {
      id:1,
      opt:1
    },
    {
      id:2,
      opt:2
    },
    {
      id:3,
      opt:3
    },
  ]

  const drpfuncshow=(myshow)=>{
    setShow(myshow)
  }

  const drpfuncflexnameMod1=(myval,myid)=>{
    setflexnameMod1(myval)
  }

  const drpfuncflexvalueset=(myflexval)=>{
    setflexvaluesetdrp(myflexval)
  }
  const handleActiveFrom = (activefromval)=>{

    if(activefromval != null){

        var dtmnt = activefromval.$M + 1;
        var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
        setactivefrom(dtfinalc)
    }
    
    
}
  const handleActiveTo = (activetoval)=>{

    if(activetoval != null){

        var dtmnt = activetoval.$M + 1;
        var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
        setactiveTo(dtfinalc)
    }
    
    
}
//start
  return (
    <>
        <div className="felxvaluecompmbmain">
            <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>Flex Value</h3>
                </div>
                <div className="admbwrap bt0">
                    <Row>
                        <Col xs={12}>
                        <div className="basicinput">
                            
                        <button className='cmbutton' onClick={handleShow}> <AiOutlinePlus/> New Flex Value</button>
                        </div>
                        </Col> 
                        <Col xs={12}>
                            <div className="basicinput">
                            <p>Flex Value Set</p>
                            <div className="dropdownwrapper">
                            
                                <Dropdown2 func={drpfuncflexvalueset} myplaceholder="Select Type" fontsize="12px" fontfamily="'Poppins', sans-serif"  options={optionsFlexValueSet}/>
                            </div>
                            </div>
                            </Col>
                            <Col xs={12}>
                            <div className="basicinput h35p">
                                  <p>Short Name</p>
                                  <div className="inputgap h35">
                                          <input style={bordershortnameMain ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={shortnameMain} onChange={(e) => setshortnameMain(e.target.value)} />
                                          <label>{labelshortnameMain}</label>
                                        </div>
                                  </div>
                            </Col>
                            <Col xs={6} className="pr5">
                            <div className="basicinput">
                                <p>Active from</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    
                                    value={activefrom}
                                    onChange={(newvaldob)=>handleActiveFrom(newvaldob)}
                                    renderInput={(params) => <TextField {...params}inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Active From"
                                        }} error={false} />}
                                />
                                </LocalizationProvider>
                            </div>
                            </Col>
                            <Col xs={6} className="pl5">
                            <div className="basicinput">
                                <p>Active To</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    
                                    value={activeto}
                                    onChange={(newvaldob)=>handleActiveTo(newvaldob)}
                                    renderInput={(params) => <TextField {...params}inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Active To"
                                        }} error={false} />}
                                />
                                </LocalizationProvider>
                            </div>
                            </Col>
                    </Row>
                </div>
                <div className="admbwrap">
                    <Row>
                        <Col xs={3} className="pr5">
                        <div className="basicinput">
                        <p>Show</p>
                        <div className="dropdownwrapper">
                            
                            <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowt}/>
                        </div>
                        </div>
                        </Col>
                        <Col xs={9} className="pl5">
                        <div className="basicinput">
                              <p>Search</p>
                              <div className="wrap">
                              <input type="text" placeholder="Search" />
                              <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                              </div>
                            </div>
                        </Col>
                        <Col xs={12}>
                        <Purplebutton btnname="Flex Set" w="100%" h="40px" mt="0px" clickfunc={()=>setShow4(true)} />
                        </Col>
                    </Row>
                </div>
                <div className="admbwrap">
                    <div className="tablewrapscroll">
                <div className="flexvaluetable">
                    <table>
                      <thead>
                        <tr>
                            {
                              flexValueTable.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      <tbody>
                        {
                          currentItems?

                          currentItems.map((item,key)=>{
                            return(
                              <tr>
                                <td>{item.id}</td>
                                <td>{item.flexvalue}</td>
                                <td>{item.flexshortvalue}</td>
                                <td>{item.attribute1}</td>
                                <td>{item.attribute2}</td>
                                <td>{item.attribute3}</td>
                                <td>{item.attribute4}</td>
                                <td>{item.attribute5}</td>
                                <td>{item.activefrom}</td>
                                <td>{item.activeto}</td>
                                <td>
                                  <div className="img text-center">
                                    <img onClick={handleShow3} src={item.action} alt="" />  
                                  </div>  
                                </td>
                              </tr>
                            )
                          })
                          :""
                        }
                      </tbody>
                         
                    </table>
                  </div>

                    </div>
                </div>
                <div className="admbwrap">
                <Row>
                  <Col xs={12} className='text-center'>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {flexValueTable.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col xs={12} className="m-auto text-center">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel=""
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={0}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                </div>
                {/* modal1ori */}
                <Modal dialogClassName="mymodal" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Flex Value</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col lg={6}>
                    <div className="basicinput h35p">
                      <p>Flex Name</p>
                      <div className="inputgap mbp h35">
                              <input style={borderflexnameMod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexnameMod1} onChange={(e) => setflexnameMod1(e.target.value)} />
                              <label>{labelflexnameMod1}</label>
                            </div>
                      </div>
                    </Col>
                    <Col lg={6}>
                    
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h35p">
                            <p>Flex Short Name</p>
                            <div className="inputgap h35">
                              <input style={borderflexshortnameMod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexshortnameMod1} onChange={(e) => setflexshortnameMod1(e.target.value)} />
                              <label>{labelflexshortnameMod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h35p">
                            <p>Attribute 1</p>
                            <div className="inputgap h35">
                              <input style={borderattribute1Mod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute1Mod1} onChange={(e) => setattribute1Mod1(e.target.value)} />
                              <label>{labelattribute1Mod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h35p">
                            <p>Attribute 2</p>
                            <div className="inputgap h35">
                              <input style={borderattribute2Mod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute2Mod1} onChange={(e) => setattribute2Mod1(e.target.value)} />
                              <label>{labelattribute2Mod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h35p">
                            <p>Attribute 3</p>
                            <div className="inputgap h35">
                              <input style={borderattribute3Mod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute3Mod1} onChange={(e) => setattribute3Mod1(e.target.value)} />
                              <label>{labelattribute3Mod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h35p">
                            <p>Attribute 4</p>
                            <div className="inputgap h35">
                              <input style={borderattribute4Mod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute4Mod1} onChange={(e) => setattribute4Mod1(e.target.value)} />
                              <label>{labelattribute4Mod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h35p">
                            <p>Attribute 5</p>
                            <div className="inputgap h35">
                              <input style={borderattribute5Mod1 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute5Mod1} onChange={(e) => setattribute5Mod1(e.target.value)} />
                              <label>{labelattribute5Mod1}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h35p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefromMod1}
                              onChange={(newvaldob)=>handleactivefromMod1(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefromMod1 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefromMod1}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                <Col lg={6}>
                <div className="basicinput h35p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetoMod1}
                              onChange={(newvaldob)=>handleactivetoMod1(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetoMod1 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivetoMod1}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveMod1}>
                    Save
                  </button>
                </Modal.Footer>
              </Modal>
               <Modal dialogClassName="mymodal2" show={show3} onHide={handleClose3} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Flex Value</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col lg={6}>
                    <div className="basicinput h40p">
                      <p>Flex Name</p>
                      <div className="inputgap h35">
                              <input style={borderflexnameMod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexnameMod2} onChange={(e) => setflexnameMod2(e.target.value)} />
                              <label>{labelflexnameMod2}</label>
                            </div>
                      </div>
                    </Col>
                    <Col lg={6}>
                    
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h40p">
                            <p>Flex Short Name</p>
                            <div className="inputgap h35">
                              <input style={borderflexshortnameMod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexshortnameMod2} onChange={(e) => setflexshortnameMod2(e.target.value)} />
                              <label>{labelflexshortnameMod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h40p">
                            <p>Attribute 1</p>
                            <div className="inputgap h35">
                              <input style={borderattribute1Mod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute1Mod2} onChange={(e) => setattribute1Mod2(e.target.value)} />
                              <label>{labelattribute1Mod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h40p">
                            <p>Attribute 2</p>
                            <div className="inputgap h35">
                              <input style={borderattribute2Mod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute2Mod2} onChange={(e) => setattribute2Mod2(e.target.value)} />
                              <label>{labelattribute2Mod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h40p">
                            <p>Attribute 3</p>
                            <div className="inputgap h35">
                              <input style={borderattribute3Mod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute3Mod2} onChange={(e) => setattribute3Mod2(e.target.value)} />
                              <label>{labelattribute3Mod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h40p">
                            <p>Attribute 4</p>
                            <div className="inputgap h35">
                              <input style={borderattribute4Mod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute4Mod2} onChange={(e) => setattribute4Mod2(e.target.value)} />
                              <label>{labelattribute4Mod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h40p">
                            <p>Attribute 5</p>
                            <div className="inputgap h35">
                              <input style={borderattribute5Mod2 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={attribute5Mod2} onChange={(e) => setattribute5Mod2(e.target.value)} />
                              <label>{labelattribute5Mod2}</label>
                            </div>
                          </div>
                    </Col>
                    <Col lg={6}>
                    <div className="basicinput h40p">
                        <p>Active From</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activefromMod2}
                              onChange={(newvaldob)=>handleactivefromMod2(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivefromMod2 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivefromMod2}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                <Col lg={6}>
                <div className="basicinput h40p">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <div className="inputgap h40">
                          <DatePicker
                              
                              value={activetoMod2}
                              onChange={(newvaldob)=>handleactivetoMod2(newvaldob)}
                              renderInput={(params) => <TextField style={borderactivetoMod2 == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                  ...params.inputProps,
                                  placeholder: "Active From"
                                }} error={false} />}
                          />
                          <label>{labelactivetoMod2}</label>
                          </div>
                        </LocalizationProvider>
                        </div>
                </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <div className="buttonswrap d-flex">

                  <button variant="secondary" onClick={handleClose3}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveMod2}>
                    Update
                  </button>
                  </div>
                </Modal.Footer>
              </Modal>
              {/* modal3ori */}
              <Modal dialogClassName="mymodal" show={show4} onHide={handleClose4} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Flex Set</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                          <Row>
                          <Col lg={6}>
                          <div className="basicinput h40p">
                                  <p>Flex Set Name</p>
                                  <div className="inputgap h35">
                                    <input style={borderflexsetnamemod3 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexsetnamemod3} onChange={(e) => setflexsetnamemod3(e.target.value)} />
                                    <label>{labelflexsetnamemod3}</label>
                                  </div>
                                </div>
                          </Col>
                        
                          <Col lg={6}>
                          <div className="basicinput h40p">
                                  <p>Short Name</p>
                                  <div className="inputgap h35">
                                    <input style={borderflexshortnamemod3 ? { borderColor: "rgb(237, 28, 36)",padding:"5px" } : { borderColor: "rgba(0,0,0,0.2)",padding:"5px" }} type="text" value={flexshortnamemod3} onChange={(e) => setflexshortnamemod3(e.target.value)} />
                                    <label>{labelflexshortnamemod3}</label>
                                  </div>
                                </div>
                          </Col>
                          </Row>
                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <div className="d-flex">

                    <button variant="secondary" onClick={handleClose4}>
                      Close
                    </button>
              
                 
                    <button variant="primary" onClick={handlesavemod3}>
                      Save
                    </button>
                  </div>
                  
                 
                 
                </Modal.Footer>
              </Modal>
            </div>

            </div>
        </div>
    </>
  )
}

export default FlexvalueCompmb